import React, { useRef, ReactNode } from 'react';
import { Toast } from "../Common/Imports";
import axios from 'axios';
import { ToastContext } from './ToastContext';

interface ToastProviderProps {
    children: ReactNode;
}

export const ToastHelper: React.FC<ToastProviderProps> = ({ children }) => {
    const toastRef = useRef<Toast>(null);
    const defaultLife = 3000;

    // Function to show toast notification
    const showToast = (
        severity: 'success' | 'info' | 'warn' | 'error',
        summary: string,
        detail?: string, // Optional detail field, with type `string | undefined`
        life: number = defaultLife
    ) => {
        // Only pass `detail` if it's defined
        toastRef.current?.show({ severity, summary, ...(detail && { detail }), life });
    };

    // Function to handle and display errors
    const handleToastError = (error: unknown) => {
        if (axios.isAxiosError(error)) {
            // Axios-specific error handling
            const serverError = error.response?.data?.message || error.response?.data?.exception || 'Server error occurred';
            showToast('error', 'Error', serverError);
            console.error('Axios error:', error); // Log for debugging purposes
        } else if (error instanceof Error) {
            // Handle other types of errors (e.g., JS runtime errors)
            showToast('error', 'Error', error.message);
            console.error('General error:', error);
        } else {
            // Handle unknown errors
            showToast('error', 'Error', 'An unexpected error occurred');
            console.error('Unknown error:', error);
        }
    };

    return (
        <ToastContext.Provider value={{ showToast, handleToastError }}>
            {children}
            <Toast ref={toastRef} />
        </ToastContext.Provider>
    );
};

